/**
 * This global middleware checks all routes starting with '/admin' to ensure the user has
 * admin access for the corresponding merchant. By using a global middleware, we avoid
 * the error-prone process of manually assigning it to each individual page within the
 * /admin directory, ensuring consistent protection and easier maintenance.
 */

import { useMerchantSlug } from '~/composables/useMerchantSlug';
import { useSupabaseUser } from '~/composables/useSupabaseUser';
import { useAdminMerchantsQuery } from '~/queries/useAdminMerchantsQuery';

export default defineNuxtRouteMiddleware(async (to) => {
	if (!to.path.includes('/admin')) {
		return;
	}

	const user = useSupabaseUser();

	if (!user.value) {
		return abortNavigation(new Error('Not authenticated'));
	}

	const merchantSlug = useMerchantSlug(to);

	if (!merchantSlug.value) {
		return;
	}

	const { data: merchants, suspense } = useAdminMerchantsQuery();

	await suspense();

	const merchant = merchants.value?.find((m) => m.slug === merchantSlug.value);

	if (!merchant) {
		return abortNavigation({
			status: 403,
			message: 'User has no admin privileges',
		});
	}
});
